export default function Separator({ className }: { className?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="30" viewBox="0 0 2 30" fill="none" className={className}>
            <path fillRule="evenodd" clipRule="evenodd" d="M0.698486 0.136063H1.86078V29.1934H0.698486V0.136063Z" fill="#02F7D4" />
        </svg>
    )
}